import React, { useState } from 'react';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Link,
  CircularProgress,
} from '@mui/material';
import { auth } from '../services/api/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const RegisterPage = () => {
 const navigate = useNavigate()
  const [details, setFormDetails] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false)

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormDetails({ ...details, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const tempErrors = {};
    if (!details.name) tempErrors.name = 'Name is required';
    if (!details.username) tempErrors.username = 'Username is required';
    if (!details.email) tempErrors.email = 'Email is required';
    if (!details.phone) tempErrors.phone = 'Phone number is required';
    if (!details.password) tempErrors.password = 'Password is required';
    if (details.password !== details.confirmPassword)
      tempErrors.confirmPassword = 'Passwords do not match';
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    formData.append('name',details.name)
    formData.append('username',details.username)
    formData.append('email',details.email)
    formData.append('phone_number',details.phone)
    formData.append('password',details.password)
    formData.append('password_confirmation',details.confirmPassword)
    if (validate()) {
     setLoading(true)
     auth.signUp(formData).then((res)=>{
      toast.info(res.data?.message)
      if(res.status === 200){
       navigate('/auth/verify-reg')
      }
     }).catch((err)=>console.log(err)).finally(()=>setLoading(false))
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 6 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Register
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {[
              { name: 'name', label: 'Full Name' },
              { name: 'username', label: 'Username' },
              { name: 'email', label: 'Email', type: 'email' },
              { name: 'phone', label: 'Phone Number' },
              { name: 'password', label: 'Password', type: 'password' },
              { name: 'confirmPassword', label: 'Confirm Password', type: 'password' },
            ].map(({ name, label, type = 'text' }) => (
              <Grid item xs={12} sm={6} key={name}>
                <TextField
                  fullWidth
                  name={name}
                  label={label}
                  type={type}
                  value={details[name]}
                  onChange={handleChange}
                  error={!!errors[name]}
                  helperText={errors[name]}
                />
              </Grid>
            ))}

            <Grid item xs={12}>
              <Button type="submit" fullWidth variant="contained" size="large" disabled={loading === true}>
                {loading ? <CircularProgress /> :'Register'}
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Typography align="center" variant="body2">
                Already have an account?{' '}
                <Link href="/auth/login" underline="hover">
                  Login
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Container>
  );
};

export default RegisterPage;
